export default __webpack_public_path__ + "static/media/rsz_schoz.83bddcba.png";